(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function(){
         jQuery(".brandstitle").click(function(e){  
        let a =     jQuery('.header-sticky-wrapper').height();
        let target = jQuery(this).attr('data-target');
         jQuery('html, body').animate({
              scrollTop: jQuery("#"+target).offset().top- (a)
        }, 1000); 
       }); 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mechanism_card"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function(){
         jQuery(".brandstitle").click(function(e){  
        let a =     jQuery('.header-sticky-wrapper').height();
        let target = jQuery(this).attr('data-target');
         jQuery('html, body').animate({
              scrollTop: jQuery("#"+target).offset().top- (a)
        }, 1000); 
       }); 
});

  } catch(e) { console.error(e); }
})();
})();
